import axios from 'axios';
import { useEffect, useState } from 'react';

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
}

export const generateUid = (cacheName = null) => {
  if(cacheName){
    if(window.sessionStorage.getItem(cacheName)){
      return window.sessionStorage.getItem(cacheName);
    } else {
      let Uid = s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
      window.sessionStorage.setItem(cacheName, Uid);
      return Uid;
    }
  } else {
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
  }
}

export const csvToArray = (str, delimiter = "--/--") => {
    
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");
    const arr = rows.map(function (row) {
      const values = row.split(delimiter);
      const el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });
  
    // return the array
    return arr;
 };

export const ga4Event = (event, category, subcategory, description = "") => {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: event,
    category: category,
    subcategory: subcategory,
    description: description
  });
  {/* implementation: https://app.clickup.com/t/86937z8r8 */}
  if(event.includes("error") && !category.includes("recurly")){
    try{
      let event247 = new Error(`${event}, ${category}${(subcategory?", " + subcategory:"")}${(description?", " + description:"")}`);
      throw event247;
    } catch (error) {
      const e = new ErrorEvent('error', {message:'ga4 event', error:error})
      window.dispatchEvent(e)
    }
  }
}

export const onlyUnique = (value) => {
  return value.filter((val, index, self) => {return self.indexOf(val) === index;});
}

export const sortNumArray = (array) => {
  return array.sort((a,b)=> {return Number(a.match(/(\d+)/g)[0]) - Number((b.match(/(\d+)/g)[0]));})
}

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const addError = (element, message, redBorderEl, skipScroll = false, skipRemove = false) => {
  if(!skipScroll) element.scrollIntoView();
  if(!skipRemove) removeErrorConfirm();
  const errorEl = document.createElement("div");
  errorEl.classList.add('error-message');
  if(message){
    errorEl.innerHTML = message.split("---")[0];
    if (message.split("---")[1]){
      errorEl.innerHTML += "<div>"+message.split("---")[1]+"</div>"
    }
  } else {
    errorEl.style.opacity="0";
    errorEl.innerHTML = "empty";
  }
  if (redBorderEl) redBorderEl.classList.add('error-border');
  element.after(errorEl);
}

export const addConfirm = (element, message) => {
  removeErrorConfirm();
  const errorEl = document.createElement("div");
  errorEl.classList.add('confirm-message');
  errorEl.innerHTML = message.split("---")[0];
  if (message.split("---")[1]){
    errorEl.innerHTML += "<div>"+message.split("---")[1]+"</div>"
  }
  element.after(errorEl);
}


export const removeErrorConfirm = () => {
  document.querySelectorAll(".error-message, .checkout-payment-error").forEach(errorMessage => {
    errorMessage.remove();
  });
  document.querySelectorAll(".confirm-message").forEach(confirmMessage => {
    confirmMessage.remove();
  });
  document.querySelectorAll(".error-border").forEach(errorBorder => {
    errorBorder.classList.remove("error-border");
  });
}

export const capitalize = (sentence) => {
  const words = sentence.split(" ");
  return words.map((word) => { 
      return word[0].toUpperCase() + word.substring(1).toLowerCase(); 
  }).join(" ");
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const freshDeskReport = async (email, name, description, title, tag1, tag2 = null, tag3 = null) => {
  let machineId = getCookie("mtm-id");
  const values = "email=" + encodeURIComponent(email) + 
                "&fullname=" + encodeURIComponent(name) + 
                "&subject="+ encodeURIComponent(title) +
                "&tag1="+ tag1 +
                "&description=" + encodeURIComponent(description + (machineId && (", machineID:" + machineId))) + 
                (tag2?"&tag2=" + tag2:"")+ 
                (tag3?"&tag3=" + tag3:"");
  const response = await fetch('/wp-content/themes/misstomrs/php/freshdesk-ticket.php?' + values)
  return response.json();
}

export const sendEmail = async (to, name_to, var_from, name, subject, contents) => {
  const values = "name=" + encodeURIComponent(name) + 
                "&name_to="+ encodeURIComponent(name_to) +
                "&to="+ encodeURIComponent(to) +
                "&from=" + encodeURIComponent(var_from) + 
                "&subject=" + encodeURIComponent(subject) + 
                "&contents=" + encodeURIComponent(contents);
  const response = await fetch('/wp-admin/admin-ajax.php?action=sib_send_email2&'+values);
  return response.json();
}


export const sibAdd = async (email, listId)=>{
  var values = 'email=' + encodeURIComponent(email) + "&list_id=" + listId;
  const response = await fetch('/wp-admin/admin-ajax.php?action=sib_signup&' + values);
  return response.json();
}

export const appendScript = (scriptToAppend, id = null, innerHTML = null) => {
  const script = document.createElement("script");
  script.src = scriptToAppend;
  document.head.appendChild(script);
  if(id && innerHTML){
    const script2 = document.createElement("script");
    script2.id = id;
    script2.innerHTML = innerHTML;
    document.head.appendChild(script2);
  }
}

export const removeScript = (scriptToremove, idToRemove = null) => {
  let allsuspects=document.getElementsByTagName("script");
  for (let i=allsuspects.length; i>=0; i--){
    if ((allsuspects[i] && allsuspects[i].getAttribute("src")!==null 
    && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`) !== -1) || (idToRemove && allsuspects[i] && allsuspects[i].getAttribute("id")!==null 
    && allsuspects[i].getAttribute("id").indexOf(`${idToRemove}`) !== -1)){
      allsuspects[i].parentNode.removeChild(allsuspects[i])
    }    
  }
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getGeoInfo = async () => {
  const response = await fetch('https://ipapi.co/json/');
  return response.json();
};

export const facebookEvent = async (action_name, data) => {
  const values = {...data,
                  url:window.location.href};
  await axios.post('/wp-admin/admin-ajax.php?action='+action_name,values).then(response => {
    return response.json();
  }).catch(error=>{
    return error;
  });
}

export const getNameChangeUrl = async (address) => {
  const response = await fetch("/wp-content/themes/misstomrs/php/my-account.php?action=recurly_get_info&address=" + address);
  return response.json();
}

export const getCyGetInfo = async (email) => {
  const response = await fetch("/wp-admin/admin-ajax.php?action=cy_get_customer&email=" + encodeURIComponent(email));
  return response.json();
}

export const getShopifyGetInfo = async (email) => {
  const response = await fetch("/wp-admin/admin-ajax.php?action=shopify_get_customer&email=" + encodeURIComponent(email));
  return response.json();
}

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);
  useEffect(
    () => {
      const mediaQuery = window.matchMedia(query);
      setMatches(mediaQuery.matches);
      const handler = (event) => setMatches(event.matches);
      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // Empty array ensures effect is only run on mount and unmount
  );
  return matches;
}

export const useBreakpoints = () => {
  const breakpoints = {
    isXs: useMediaQuery("(max-width: 576px)"),
    isSm: useMediaQuery("(min-width: 577px) and (max-width: 768px)"),
    isMd: useMediaQuery("(min-width: 769px) and (max-width: 992px)"),
    isLg: useMediaQuery("(min-width: 993px) and (max-width: 1200px)"),
    isXl: useMediaQuery("(min-width: 1200px) and (max-width: 1400px)"),
    isXxl: useMediaQuery("(min-width: 1401px)"),
    active: "xs"
  };
  if (breakpoints.isXs) breakpoints.active = "xs";
  if (breakpoints.isSm) breakpoints.active = "sm";
  if (breakpoints.isMd) breakpoints.active = "md";
  if (breakpoints.isLg) breakpoints.active = "lg";
  if (breakpoints.isXl) breakpoints.active = "xl";
  if (breakpoints.isXxl) breakpoints.active = "xxl";
  return breakpoints;
}